import { parseSemver } from '@sentry/core';

const NODE_VERSION = parseSemver(process.versions.node) ;
const NODE_MAJOR = NODE_VERSION.major;
const NODE_MINOR = NODE_VERSION.minor;

export { NODE_MAJOR, NODE_MINOR, NODE_VERSION };
//# sourceMappingURL=nodeVersion.js.map
